import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { getColor, getSize } from '@lib/common';
import styled from '@xstyled/styled-components';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: ", ";\n  vertical-align: middle;\n  margin: ", ";\n  flex-wrap: wrap;\n"])), getSize('padding8'), getSize('padding8'));
var IndexCircle = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  line-height: 1;\n  flex-shrink: 0;\n"])), getSize('padding24'), getSize('padding24'), getColor('fillIntActive'), getColor('fillBgWhite'), getSize('typo12'));
var Input = styled.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  min-width: 150px;\n  max-width: 250px;\n  width: auto;\n  border: 2px solid\n    ", ";\n  border-radius: 12px;\n  outline: none;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  padding: ", " ", ";\n  background: ", ";\n  transition: border-color 0.2s ease;\n\n  &::placeholder {\n    color: #9ca3af;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n"])), function (_ref) {
  var $isFocused = _ref.$isFocused,
      $hasValue = _ref.$hasValue,
      theme = _ref.theme;

  if ($isFocused) {
    return getColor('fillIntActive')({
      theme: theme
    });
  }

  if ($hasValue) {
    // Highlight border when has value (answered)
    return getColor('fillIntActive')({
      theme: theme
    });
  }

  return '#cbd5e1';
}, getSize('typo14'), getSize('padding20'), getColor('contentTitle'), getSize('padding8'), getSize('padding12'), getColor('fillBgWhite'));
export var FillInBlankInput = function FillInBlankInput(_ref2) {
  var index = _ref2.index,
      uuid = _ref2.uuid,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? '' : _ref2$value,
      _onChange = _ref2.onChange,
      readOnly = _ref2.readOnly,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? 'Nhập đáp án...' : _ref2$placeholder;

  var _useState = useState(false),
      isFocused = _useState[0],
      setIsFocused = _useState[1];

  var hasValue = !!value && value.trim().length > 0;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(IndexCircle, {
      children: index
    }), /*#__PURE__*/_jsx(Input, {
      id: uuid,
      defaultValue: value,
      onChange: function onChange(e) {
        return _onChange === null || _onChange === void 0 ? void 0 : _onChange(e.target.value);
      },
      onFocus: function onFocus() {
        return setIsFocused(true);
      },
      onBlur: function onBlur() {
        return setIsFocused(false);
      },
      disabled: readOnly,
      autoComplete: "off",
      placeholder: placeholder,
      $hasValue: hasValue,
      $isFocused: isFocused
    })]
  });
};